import React from 'react';
import { Link } from 'react-router-dom';
import './CTASection.css';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="container cta-content">
        <h2>Ready to Transform Your Business?</h2>
        <p>Let's collaborate to build intelligent, integrated solutions that drive real-world impact.</p>
        <Link to="/contact" className="btn btn-gradient">Get in Touch Today</Link>
      </div>
    </section>
  );
};

export default CTASection;